import { Box } from "@mui/material";
import { LeadsManagementData } from "../hooks/useLeadsManagementData";
import AnalyticsFilterCard from "./AnalyticsFilterCard";
import AnalyticsKpiCards from "./AnalyticsKpiCards";
import LeadScoreDistributionChart from "./LeadScoreDistributionChart";
import IncomeByBrandChart from "./IncomeByBrandChart";
import LeadsByDayChart from "./LeadsByDayChart";
import LeadsByBrandChart from "./LeadsByBrandChart";
import AnalyticsSkeleton from "./AnalyticsSkeleton";

interface AnalyticsProps {
  data: LeadsManagementData;
}

export default function Analytics({ data }: AnalyticsProps) {
  // "By brand" breakdown charts are meaningless once the data is already
  // filtered down to a single brand (they'd only ever show one row) — the
  // server's by_brand/income_by_brand aggregations come back empty in that
  // case too, which was rendering as blank/near-empty cards rather than
  // being hidden outright.
  const showByBrandCharts = data.brand === "All";

  return (
    <Box sx={{ mt: 2 }}>
      <AnalyticsFilterCard data={data} />

      {data.isLoading ? (
        <AnalyticsSkeleton showByBrandCharts={showByBrandCharts} />
      ) : (
        <>
          <AnalyticsKpiCards data={data} />
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: showByBrandCharts ? "1fr 1fr" : "1fr",
              gap: 2.5,
              mt: 2.5,
            }}
          >
            <LeadScoreDistributionChart data={data} />
            {showByBrandCharts && <IncomeByBrandChart data={data} />}
          </Box>
          <LeadsByDayChart data={data} />
          {showByBrandCharts && <LeadsByBrandChart data={data} />}
        </>
      )}
    </Box>
  );
}
